import { t } from 'i18next';
export const columns = [
  {
    field: 'sequence_number',
    headerName: t('invoice'),
    size: 2,
  },
  {
    field: 'invoice_date',
    headerName: t('invoiceDate'),
    size: 2,
  },
  {
    field: 'due_date',
    headerName: 'Due Date',
    size: 2,
  },
  {
    field: 'paid_date',
    headerName: t('paymentDate'),
    size: 2,
  },
  {
    field: 'status',
    headerName: 'Status',
    size: 1,
  },
  {
    field: 'total_amount',
    headerName: 'Amount',
    type: 'number',
    size: 2,
  },
  {
    field: 'share',
    headerName: '',
    size: 1,
    type: 'icon',
  },
];

export const cardFields = {
  firstName: {
    selector: '#chargify-firstName',
    label: '',
    placeholder: 'First Name',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '3px',
        width: '227.5px',
      },
      input: {
        width: '227.5px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '227.5px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  lastName: {
    selector: '#chargify-lastName',
    label: '',
    placeholder: 'Last Name',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '3px',
        width: '227.5px',
      },
      input: {
        width: '227.5px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '227.5px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  number: {
    selector: '#chargify-cardinfo',
    label: '',
    placeholder: 'Card Number *',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '8px',
        width: '479px',
        marginLeft: '8px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '66px',
        paddingRight: '20px',
        paddingBottom: '14px',
        marginTop: '-8px',
        marginLeft: '-8px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '479px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  month: {
    selector: '#chargify-cardmonth',
    label: '',
    placeholder: 'Month *',
    style: {
      field: {
        paddingTop: '3px',
        width: '143.6px',
      },
      label: {
        width: '143.6px',
        display: 'none',
      },
      input: {
        width: '143.6px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  year: {
    selector: '#chargify-cardyear',
    label: '',
    placeholder: 'Year *',
    style: {
      field: {
        paddingTop: '3px',
        width: '143.6px',
      },
      label: {
        width: '143.6px',
        display: 'none',
      },
      input: {
        width: '143.6px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  cvv: {
    selector: '#chargify-cardcvv',
    label: 'CVV',
    placeholder: 'CVV',
    style: {
      field: {
        paddingTop: '3px',
        width: '143.6px',
      },
      label: {
        width: '143.6px',
        display: 'none',
      },
      input: {
        width: '143.6px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  address: {
    selector: '#chargify3',
    label: 'Billing Address',
    placeholder: 'Billing Address',
    required: false,
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },

  city: {
    selector: '#chargify3',
    label: 'City',
    placeholder: 'City',
    required: false,

    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  country: {
    selector: '#chargify3',
    label: 'Country',
    value: 'US',

    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  state: {
    selector: '#chargify3',
    label: 'State',
    placeholder: 'Select State',
    required: false,
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  zip: {
    selector: '#chargify3',
    label: 'Zip Code',
    placeholder: 'Zip Code',
    required: false,

    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
};

export const bankFields = {
  firstName: {
    selector: '#chargify-firstName',
    label: '',
    placeholder: 'First Name',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '3px',
        width: '227.5px',
      },
      input: {
        width: '227.5px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  lastName: {
    selector: '#chargify-lastName',
    label: '',
    placeholder: 'Last Name',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '3px',
        width: '227.5px',
      },
      input: {
        width: '227.5px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  bankName: {
    selector: '#chargify-bankName',
    label: '',
    placeholder: 'Bank Name *',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  routingNumber: {
    selector: '#chargify-routingNumber',
    label: '',
    placeholder: 'Routing Number *',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  accountNumber: {
    selector: '#chargify-accountNumber',
    label: '',
    placeholder: 'Account Number *',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  accountHolderType: {
    selector: '#chargify-accountHolderType',
    label: '',
    placeholder: 'Account Holder Type *',
    message: 'This field is not valid. Please update it.',
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  address: {
    selector: '#chargify3',
    label: 'Billing Address (Optional)',
    placeholder: 'Billing Address (Optional)',
    required: false,
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },

  city: {
    selector: '#chargify3',
    label: 'City',
    placeholder: 'City',
    required: false,

    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  country: {
    selector: '#chargify3',
    label: 'Country',
    value: 'US',
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  state: {
    selector: '#chargify3',
    label: 'State',
    placeholder: 'Select State',
    required: false,
    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
  zip: {
    selector: '#chargify3',
    label: 'Zip Code',
    placeholder: 'Zip Code',
    required: false,

    style: {
      field: {
        paddingTop: '3px',
        width: '479px',
      },
      input: {
        width: '479px',
        color: '#556677',
        fontSize: '14px',
        maxHeight: '56px',
        minHeight: '56px !important',
        fontWeight: 600,
        paddingTop: '15px',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '14px',
        borderWidth: 0,
        borderBottomWidth: '1px',
        borderColor: '#c3c4c3',
      },
      label: {
        width: '534px',
        display: 'none',
      },
      message: {
        color: '#CF383C',
        margin: 0,
        fontWeight: '400px',
        lineHeight: '12px',
        paddingTop: '5px',
        paddingLeft: '22px',
      },
    },
  },
};

export const letter15 = {
  letterSpacing: '0.15px',
  color: 'text.primary',
};

export const fontSecondary = {
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '36px',
  color: 'text.primary',
};

export const borderPopup = (theme) => ({
  backgroundColor: 'uncategorized.card',
  borderColor: theme.palette.info.outlinedRestingBorder,
  borderWidth: '1px',
  borderRadius: '16px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
});

export const CancelSubscriptionImage2 = () => {
  return (
    <svg
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        x="0.811035"
        y="48.9414"
        width="90%"
        height="100%"
        transform="rotate(-7.37482 0.811035 48.9414)"
        fill="url(#pattern0)"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_661_40354"
            transform="translate(-0.194245 -0.202381) scale(0.00719425 0.00595238)"
          />
        </pattern>
        <image
          id="image0_661_40354"
          width="188"
          height="475"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const ExitImage = () => {
  return (
    <svg
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        y="24.125"
        width="100%"
        height="100%"
        transform="rotate(-3.27325 0 24.125)"
        fill="url(#pattern0)"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_661_40432"
            transform="translate(-0.000500438) scale(0.0070493 0.00531915)"
          />
        </pattern>
        <image
          id="image0_661_40432"
          width="142"
          height="188"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const NoteIcon = () => {
  return (
    <svg
      width="36"
      height="40"
      viewBox="0 0 36 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12H28V16H8V12ZM8 24H28V20H8V24ZM8 32H28V28H8V32ZM36 0V36C36 37.0609 35.5786 38.0783 34.8284 38.8284C34.0783 39.5786 33.0609 40 32 40H4C2.93913 40 1.92172 39.5786 1.17157 38.8284C0.421424 38.0783 0 37.0609 0 36V0H4C4 0.530433 4.21071 1.03914 4.58578 1.41422C4.96086 1.78929 5.46957 2 6 2C6.53043 2 7.03914 1.78929 7.41422 1.41422C7.78929 1.03914 8 0.530433 8 0H12C12 0.530433 12.2107 1.03914 12.5858 1.41422C12.9609 1.78929 13.4696 2 14 2C14.5304 2 15.0391 1.78929 15.4142 1.41422C15.7893 1.03914 16 0.530433 16 0H20C20 0.530433 20.2107 1.03914 20.5858 1.41422C20.9609 1.78929 21.4696 2 22 2C22.5304 2 23.0391 1.78929 23.4142 1.41422C23.7893 1.03914 24 0.530433 24 0H28C28 0.530433 28.2107 1.03914 28.5858 1.41422C28.9609 1.78929 29.4696 2 30 2C30.5304 2 31.0391 1.78929 31.4142 1.41422C31.7893 1.03914 32 0.530433 32 0H36ZM32 36V6H4V36H32Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TopLeftCircle = () => {
  return (
    <svg
      width="39"
      height="56"
      viewBox="0 0 39 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.9067" cy="27.9067" r="27.9067" fill="#1E88E5" />
    </svg>
  );
};

export const BottomRightCircle = () => {
  return (
    <svg
      width="48"
      height="28"
      viewBox="0 0 48 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24.62" cy="24.3402" r="23.66" fill="#1565C0" />
    </svg>
  );
};

export const BottomRightCornerCircle = () => {
  return (
    <svg
      width="21"
      height="53"
      viewBox="0 0 21 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="29.1667" cy="28.7135" r="28.5133" fill="#1E88E5" />
    </svg>
  );
};

export const CancelSubscriptionImage1 = () => {
  return (
    <svg
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        y="67.2334"
        width="90%"
        height="100%"
        transform="rotate(-7.74341 0 67.2334)"
        fill="url(#pattern0)"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_661_40301"
            transform="translate(-0.429204 -0.109091) scale(0.00442478 0.00454546)"
          />
        </pattern>
        <image
          id="image0_661_40301"
          width="341"
          height="343"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVUAAAFXCAYAAAASxN0lAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAHg1JREFUeJzt3WlsHOd9x3GnRdEWBVohbKz4nLUlWdZN67AlUZaWum+R1EFJlGxKlq3LcmhJsSIrcTaN4jiO7ciOfKf2Jjaco0nBNAHiBAHBV31ToFXRoiiCoiCavkiTBmGKIm2Kpk+f/+zMaricmZ1zn93l9wP8YZriMTPk/vjMc80NNwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJx13Hh7p64hXWVdo05d0VUwfWwA0HR0OA7qGtZVct4uOm/L+8Z1qZAqmT5+AGg6ToiGhWdYlU0fPwA0BR2I05yWadG5xZdb+2sJgrVk+lwAoOGkH9RplSYJznpVdLoPSk4VTJ8vAOTCCbzRHIKUFiyAqSVlf2kWVTZ9DQAgEx2VaVAmA5VgBdD6OioDUM0SqG4Nmr4uABBJx/VR/KjzS02UHFPB9LUCgFAdldVNpgOTbgAAra/D/CBUkppm+roBgC8dUGNOmQ7KOFU0fd0AYJKOykYnw00QkoQqgNbXURmYMh2QhCqA9tCirVQp+lQBNJ+O5pw2FaU6TV87AJikkaHavXRZ9e1bb50Z+fM+fPOdfu+X4+4xff0AYIKOBtz+3zVjjvrcgzvU4Q3F6vtObF+X1dcfNH0NAaCqo7L/aSbBuWXlCjs4z/VtskNU6iuP7lYjlw7Y5YaqfFyGoUqwAmgeHZW9UWMHqPc2XkLUDc6wcoNU/ptxqEoVTF9LALB1xNhsWkJ0T3FV9f+lNRolUKWk1ep+jlTGoVo2fR0BwNYRY93/U/u3VluqchsfNVDdWr7oHjtQh8/tyzpUx0xfRwBwd6aqOwPAb7ApTivVLQll9/O8Ld4syvS1BIC6o/+L5iyw+0ylZSn/dd+fpJVaW/I140ytoqUKoKnpIOoJC6oHNharAfjKIz32++bOmqce3NRt/3+U0JSWrdzyS8nb0lL1fkyGfaujpq8ngCmuo87OVGuXLZsQqtJqre0SqA1J70h/UCvU7UpwP9bbAk5RZdPXE8AU1lF5DHRoUEnr0g0+7zQqeVv6Q8P6VGWkX8JSWqfysfK1akPWOxUrg2AdMn1NAUxhHRE2ppYQdENvxpz71dJVh9WjBz6qXn/scTX8xEOR+k2/97EH1LMnL6mjh6+oDfveVF1731Kbez6tltz/kJo5a7HdReB+bMqBq6LpawpgCqvXn+rWnxwvqQ39b6pVu55Rxx58Wl069ax64MGrdjiee+hZOzSDAlXCV4JUPv4L5z6l3vnEBbvk7YcGP69W7X5VHel9eNKKK7+aftMdoYNapq8nAIQ+enr6LbPVyu2XVc+BL6pXLjyl1q3bor59eaha3yidV48cfckOza+dO+kfqDqMnxm6POHzvHX50bNq9Z7X1IunL0xYceUt6cd1B8Ve1f8NClbT1xIAbB0BU6qWrHnYbp1+5vSJwFCUkpbrrgOvTWixytsStmGB6tbLT1y0W73SnVA7E0D6br91dq969egm9cLhdfbX3tq1Iqi1ylaAQBL6hdWjq6RrSFfB9PG0ug6fDVWsWcvsW/O7l3SrY/391QB848JJtXt7j91qHejdbf+/vF9u76Xf1A1VeVve537ee0+dUQ/t61dLV6xVd3V22SVvy/vk3848/AXVf/Cq2r7vqlrafap6HNJCffvENvX5gW714oPr7a8t07wY/Qcyol9UZZ++u0HTx9XKOnymVS3tPq1bqZ9TXTs/XQ3Vp44fqQbi4uXdasHSNerue1apZ848bPeRHhy4Wv2ZnB58rtpKffHscbVw2Rp1X9d61b12s3pg9x47lN2v1bV6o929sPvAK6p0+HD1GKR/dfhsnx2o0lJ1v3ZIqI6bvpZAywkIVSlu/RLoqDz0b1JArdz2aV1PqkVdfdVQlVapBKm0LqXcULx35Tq7f1Vu4Y8d/oJdOw68ZgelfN76dVurHyu1bfMO+/3njzxgvy0tVfl/+XyZ8+rOOpBZARKmEqpfObVDfXOot7p3QG2Yet4umL6mQEtxbvv9QvWa6WNrRUHTqpZvvmQHqoSg9/bfLW+oSqtTglFC8ctDZ+w6dKgyuCVB/PD+/RNCtXbAS+pPn7xk98F691t1W6lS0p/6vScqU698BqpGO67vslU0fU2BlhISqlIl08fXapxAUrVdANKvuWzdscBQ/eyjx6oh+ZK+vf/80EftwSr3Z3Hp2GV1/sTz1Y+XW3z346UbofbrSVeBdBm4rVBZOPDGsc3VUP3SI5VVW588sNXvtn/Ycx4F09cUaCnSfxoSquMMXMXjCaMJ+6nOvWeb6uq9EhiqbneAO1AlA03njj5T/VnIFCuZTiXdAt4gdj++dmrWzoOvq2ePn7e/tywA+MHFfjtIZXBKQlVarSEj/0PO8Y+avp5Ay9EvrGKdFTzDpo+xlXhu/0drw2rljs+oezecCgxVt+Q2XwK0doXVuaOfU/2HXpkQrH4lgXz08Iv2MlXvzlcSpHLb7w5SBexoNe70C4/TSgUS0C+uaRGWRhaDPl+3eoq6SroKDTvoJtZR2Uu17Nz+T2ityrSqrt2vqv7+JwMDUUb9JVDdyfu1y1NPDz5vB6s7aFUbxvJvBwauTlqVJS3Vq4Mb7VaqO0B13n9vAPmjII+DmWb6WgItS7/AxuqE6pjT9zrh8cX6Bdrj9tE5NWjoFJqOG0wdNU8AkGDduud5+/b8U2eetoNQSvpAZR6qDC69/tjZ0D9yz578uN3fKl9DPkdK3pbP/fTxUuDnuV0A7v/73PqPmr5uQFsImVYVOnilQ3SsJlSlSsHfaWqqXQwg80Jlyan0mcptupQMKr2kW6dh6/5rS/pZ3dkBUjF+hnZ5d8lyBqdonQJZkMEoZ1AqyouxOiHcJ1DdKjv/Ps3pHqitKffinTC9yrP9n6l61dkg2x1UM319gLYzUlmqGvVFOSifo8PxSkiw+rVip2yLNk6ovnB0j/pI365MQ1QGpbxbAspm2d5jMn19gLakX2zDEV+ko+7nSKu0TnhO+WCVCfRxQvXb5/erFcvWqbUrNqiL/b3q3TP7EoepW886G6vI96657XeraPo6AW1npDIToN6glVvVZawpg7Xtl8PW9qlGuf2XYJUWq1SWoVpTY4QqkDMJy4gv1LL386TVKVN2ZHT564/tUsNndwd+roxCy7/Lx5VPbPtHCXNDp9sQtTMApKWY5a19lArYNKWHUAUaYKSyBWCk1qrzsdJtEHWga1L98MkD/9rOwdrhs79qo0O1tg/VmUNbJFSBBhmJ3r+aVV0xfc556Zi4yYq90urVOo+jHj6+U721tai+tGmNKu9cq/7iZP3HVwd+rXP7/FqpVzyhOmb6GgFtbyRe/2oW1bZ7dzoLAcY9oVr2Pqrar97Zs0GdXd2tNi5eowaWF9XVDUX1Z4PbEl1bn1v/cWdhwqC7LNX0NQKmhJHo/atZVU/9o2pNHdcfXz3mhKy9TDToWnz14GY1e+4qZc3uUks716lLfYfV81s3q++e6Y11TX2WolZD1GmpEqhAI42E72KVdZVNn2+ePC1DCbMrsplJUDfA98/vrQbqX3/sgvqnT16y//vy7p2Rr+ebJ3b57ZNaMH0dgClvJN4y1jQ1Zvpc8+a0Uoect8thwXq5t1c9139YvXr4qFNH1Mv99adXuWv8P3tw/YSNUgyfOgAv/WK91qBgLZg+10aSsLvttpm/9AvW75zuV984tLda3zqyT/3wYvj1+875PdXdqJ47NOHx1NzmA81kpDJw1YhgHTR9ro0mg0azZ865+OXTuydNS3v/8f12uMp/61279x7dae+X6n1kSuechXY/qulzBODDCVaZajUaUiVPyX4CRaemjUTbX6Bs+jxNGknQ1SLPmnIf6Oct2TfV2d6vbPq8AORkJMLeraaP0TTnj0/dxRTSd/rOqR2+y3/fPlGZfnWpf8vP2dIPaGMjPrMJXj++196V6ZHtO+26b+na89bsroLpYzXJadkHtlplia/7vKnakj5VCdxK8O7/O/drdq7aX9B1TVfbTl0DphwnLMZlwxAJ0M7Ooj11yKfoB7yhutetLAUe/e5H9/5MWqDeftPakn+TwaqaEJ4mQaprXJfSVTZ9XgAydGrXrq/Nnn9/UJh6ixaVh26B/qLerl/u86e8tW3jQNkJU7f4gwW0Cx2UgxHC1K2y6eNtJi89uOFXYYEqo//eMP3uEwdV75aDqiZQ3eIPFtAOdFBeixGqUgyy3FDpDw277fc+0E/q7TMDqnvtgaBApQsAaBc6JIsxQ3XQ9DGbooNP+kIHZXCpe+1BOzijBOqlgUNhYUoXANBudFCOxgjVYdPH22hOkA57Q7BP38bLfNTa1qo7dcq93T/aMxAlUOkCANpJgtZqwfQx5+3ue9YfW7C89/1FXfv+yy8AT+85VF2GKhP93zi2WQ2f7Ztwu79lQ2D/aVANmT5vABnRQTkWI1Tb/sU/a8Gan4QF4Ln9hwMXATz30CG1fE1o/+mkWrh896/lLkCurfNHTqrk1BXnbsKtYef9BdPXCUAA58UcNVTHTB9v3qbfOjs0BF85MeAbqBtXb4nbOrXrzvndce4UJnTHMHgINCH9wuxkwKrCfazJnMUbA0OwfObgpEB958xedUthfuxAveuezUkDtfpHTn5+pq8bgBoxuwBGTR9vXtxHWN8+c3FgEPq1UlctWW5v6ze7c13kQJ137660gerWNVqsQJNxbiXjvJCLpo85D39804z33X1PFyzvnRSEMp3KL1RvvHmm/Tn689WilXvqBuqC5X2qMCfSSrbIXQGmrx0Aj5j9qm3RWnW6PWRVWclp7f3iQzfPqm4mPWPeqklhKNOpagO1Z83Eh/n5fZ63FnXtS9OPGlZMywKahRW/X7XlWqtyi+yEqLTKx/3OyRuOfgNWMve0NlStwpxJj532a+W6NXPh+jwC1e5fNX2NAXgEBU2rt1b1cRZ0leudz20zl04KxzmLN4UOUp3euWXS50hr98559/sG6qzOjXkFqluDpq83AEeU4Gml1qrTMr0S9VxuKiycEI433nq3blVWBp5k7qlM6q9tpc6/u7P68dKfesud91S/3vz7ehsdqFL0rQLNwoq3a1VTt1adQI21YYyEqB2Q0wvq5jsWVd+/evVue9lpbaA+f6Sn+vESyLfftWLC17tj7ppqoM5duqMRgeoWMwGAZmBVbpOTvIibap5kkkCVkpam3LrfOuveCe9/4eikjabtWrJwqZp+29xJYeqtuxdvtauBgSpVNP0zAOCw4s1Xdats+rhdSQNVyi8g5WkIfoH61Y/sVbPmrGx0WEatkumfAwCHlaxfVarQBMdeN1BvnbFE3XbX8sjndWjTdt9Qvdjfazo4w+qK6Z8FAIeVrF9VqtwEx173D4L0fcY5r3fP7PMN1ZDneTVDjZr+WQBwWJXWXtIXc8HgcUdavBAnVFcsW+cbqJcP7TYdmoQq0EqshH2SlqHWqhVxT1iZ7iS3/1HPRx7V7Req21ZvMh2adcvEzwFAACvG3E6fKjT4WGUlWKRFCzJlKmykvrbeOj158xR5nLfpwCRUgRajX5Q9KV7Q5QYeZ+SRfglTmS4V9TzmLduiNvWdVocPnFTHBk6o0rFjdh3cvtd4YEaspprmBkx5KV/QuU8+d4I/8rJaufX/8O3zI5/D8u79dqjW1sL7tpsOy6hVzPtnACAGK94DAWurlONxSes09rSvG2+ZHas/df2u476hesfc1abDklAFWpFV2Q4v6QtaWpCZt1atyoBU7MUJMi/V3ng6Yn+qe+tfW8WtR0wHZZwqZX39AaRgJdsKMLcXtZVi8ExWSklLNerHB936L1nVZzooCVWglVnxtwL0ViatVSfck07xquw8Nb0waT1/WAXd+t+1aJ3poIxT5Qx+BQBkyYr/iJVMW0tWui4Ie3BKbvtln9SonxN06y9B2wRBGadGs/ktAJAZK/4jVmorUWvVquyWlWagzB6UkkD1buEXpYJu/eX9eYZgnEE0QhVoUVbyrQC9VYr5PYesdN0O9q2+3PJLX2rczw269c97KpV0U2QcrOM5/VoASMNKthWgt8Yifh+ZKpW2u8Ee4Xf3RY2zekoq6Na/EVOpZLVXnHm0USrnXw0ASVjplqy6NVjne8SayB8aTrfMjj0w5VbQrX8jplLJHwH5Y5Dx1+UJAECzsdJPrZIaC/jaiSbyB5W09KQf1fucqDi1dvsx31C9d03+S1Pd51zF2es1QhUb+9sCIBIrfReA1GDN10w0kT+o3IGpJP2oUjJdKujWX56ommeg2n3ATqjGHVgjVIEWZGXTBTDmfK1YTziNUvaKKX3LL7fPcftR3ZLWaFCo5hmolucPgvSrSmX4tQfN/uYA8GVl0wWgnDBNPJE/qOx+1JjzUWtL+k39AvX+TQ/kHqoy8i99qu682gy/dsn07w6AAFaGt+pZltwuSxClGTmfsaAY2ErtXLkr93OQPwpuC9UeZMtualXJ9O8NgABW+oUAmVcWt/1SEpxBodqIpalyDu5jXqRPOMOpVcOmf28ABLCyWQiQaUnrLu1tv1TX+gFjS1PdQSq3dSrnkuHUqlHTvzcAQlgpl45mWRI+9uBOjN2ngiqolSphm/d5VPcn8EylklDNaGrVqOnfGQAhrOSPr868qoNTKcNHpkuZ7E+V2325/fe+T7oCsppaZfp3BkAIqzIdKpOVT2nKvWVOOifVW2FTqRrRnyqt0tppVPKHIqupVaZ/ZwDUYWW4Aipp2a076YdMsBS1toKmUjWiP9V9IoFPq/SaDtufZ/R9WKoKNDMruzmricvdMCXt15FNUkz2p7rTwXz+OAxNv23OSxlNrSqa/p0BUIeVwwT+GDUuQeROQUpTYbtSNaI/NWQTlYI+x2nTb5/334QqMAVYZgasZPGBzJWdlsU0KimT/anurb/PnNRr7nXWoZrFH68ek78rACKyGrfCSoJl0Pu9swpVk/2p9rOz/G/9q+c6/ba5H8+g37jU4F8NAElYKZ8fFaFkw+qi3/f+4PTCT9Le/of1p+a93l9Wf8k0qoA5thMGlm6+o/PfCVVgCrDymV4lX09mFxTCvrcO1ffSrjoKm5+a96Oo3X1ffVrb5dpzveXOe76Z8vtN+poAmpSVXWu12l8a5fvqQOpJ2wUgwWli/1R3BVXAPNSizzVOO9tiNOufO4CcWJXWapq+VbnFTzSQom+ff5pmWlXQev889091H0gYsAHMWMh1TnONR5P+fAEYYFWeLxXnRS4BIS3cQprv67ZWky7nDHp0Sl7Po7JbqDpQQ56fNRRyjdPsEMZTVYFWY9V/CqrbV5rp9B7d4ntfQiru+v+wQSp5+F/WgeqO9EsLNWQ0P7Drw0q5Q1iW1xxAA1iVboDaOZVukA6GBUYaMkG+48N3/izuTlWN2kTFXsPvbPwifaghe76WI1zjxHNW87j2ABrAqjzMT6qzUd9TglW3AMfjTLEK25Q6q0Equ3Xq9J9GWG5a93pZ6RZcNOznAaAN3GQtsD5086yfRH00ddjIf9owlWNwd56KuHZ/NMo5WpW7gaTHVcz3JwCgLU2/fd77UR6rIpP78xikkv7SBNO8ilHPz6rfd02oAsiOFXEmQtDIfyN2pqqpWM+QspJ3AZRyuuQA2plVeQR23ZAxtZLKpwoxzy/pKrZSPlccQFuzIoyQh438y1aADQzUUsJzTLJJ+JWMLzWAdmdFHMhZeN/2wFCdsaDYqECVBRCJpplZ8RdbSI1mfLkBtLuoYZPnyH+MKqY817hdANfqf1UA8LAi9qcGrfnPe7s/T8UanAo41yRdAOUMLjOAqcKKuOIoaGPqPJan+pS0MFOvLrOS71xVzuBSA5gKogaL4ZH/zPY+sJLvXBW4cQsA2KzK0ti6gSLPnTKxh2oerUQrYndHQBWzPBYAbcaKuDVe2NNTcx75TzzaH3LOaTavzqQbAkCbitpqMzjyX8zpvNM8bTX1gBmANqUDYjRKkMhglIGR/1KO551m8+rcwh5Ai7MiDtoEbaSS48j/WM7nnWrzaotFAQD8RA0RQyP/ufZdWhFb6SHFXqsArrMiDtjIQJShkf9izuefZvNqKfYFAHCdFXE6VdhGKjLVKsdQLeV8/mk2r5ZiCSuA66yIgzUGR/5HG3ANkm5e7RbTqwBUWJXHXdcNjqCR/7weSe2p3B8RbaXvAsj0KbcAWljUVlrQyH+DdvvPfTDISrZ5tVv0qwKosCKOfq/fddzkmv/c19tbyXaucms07+MD0CKitNDumLva9G7/ua9espJtXl2tvI8PQIvQgfC/9QLD4Mi/W7n3qzrXIk0XAPNVAdhB8ny9wFi0YqfJ3f5/o+vLun67Adcizc5VbAkIwA6SP9D1z6Et1SXb1OLVB9Wy7kOqa9OR67Uh993+f9DIFqCVbueqcqOOE0CT04GwISww1j/ytNp86gW1su9xuzpX7bdr/n29eYXp3+raZOhaJN28mkUAAK5zbrF9A2PviyNq4N0fTao1AxeyDtMf6zqi67cMXofEXQCmjhlAE9Kh8EFd/+YXFn6BKnXfrpNZhekvdV3U9ftNcB3S7FxVNH38AJqIDoUDtUGxsHt/YKguTL/l3//o+qKuD5k+dy8r+ebVDFYBmEgHw3e8QSGt0aBQTRGm/6frW7ruMn2+fqzkm1eXTR87gCajg+F2Xf/hBkXx8JO+gbr/jb9KGqh/qavL9HmGSdEFwGAVgMl0OJxxg2Lr+dd8Q3XnJ96JGzg/0tVn+tyishLuXGX6uAE0IR0OH3BalGrhij3q/v4LaseFt9SBL/1NNVTXP3I5atD81Anp3zF9XnFYyXeuKpo+dgBNSIfDPF2/duek1ta8lXXnqP5K19O6/sj0uSRhJd+8msEqAP5mLFj7qaBQ1f8WFCqyrPRtXbeaPv60EnYBlE0fN4AmpcPzd3X9g1+o3jF3jV+gfF/XItPHnRUr2c5VDFYBCKYDtEvXb4JarE5d07XR9LHmwUqwc5XpYwbQ5HRgvhwQpv+i60FdHzB9jHmxkm1eXTR93ACamA7NP9T1Y0+Yjuv6mK7fM31seUvYBcBgFYBwOkB36JLZAC/p+mPTx9NIVvydq8qmjxlAC9BhepPpYzDBir9zFYNVABDESrB5teljBoCmlqALoGj6mAGgaemQLDFYBQAZseLvXFU2fcwA0NSseJtXM1gFAGGsmJtXmz5eAGhqVvydq4qmjxkAmpoVb+cqBqsAIIwVb/PqYdPHCwBNLWYXwLjp4wWApmfF27mq0/TxAkBTs+LtXHXF9PECQNOzom9ePWb6WAGg6cXsAiiaPl4AaGoSlDFCtWz6eAGg6VnRd65iFgAA1GPF27x60PTxAkBTs+JtXj1q+ngBoOlZ8XauKpg+XgBoala8natKpo8XAJqaFW/z6jHTxwsATS9GF8A4XQAAUIcVYeeq3eu2qDdP7h2I8vVGLh0o6BrUVdY1WlPDukq6hnQVdU3L+/wAoKGsgJ2rZs+/3w7Td8/sUzr8pEa9nyeB6ASjBOgVJzTHnY+NU2MSsoZOHwCyJ3NW5y9c8/ePbN+pPtK3S71wdE9QAJZThGe9otUKoL3kFJZRi9YqgPbi9HmaCtUx0+cPAJly+kdNhapUj+lrAACZGakMPpkM1VHT1wAAMtWgLgAZ7BoK+LeC6WsAAJmJ2wXwvSf2qa8/tku9cWyzujq4UQ2f7asXpkXP9xr1+ZhrBCuAtuF0AdSdBfCDi/12mH5zqNd+2w3Yt09sU185taP6Pr8wjfi9So0/ewDIwUhlPmri23sJ1Pce3an+/PG+/xxxBp/0fztHKquphp2QLXjeT7ACaF8jlZVSeferlmq+n1+wjpq7CgCQoYD+ziyrp+b7SYt1rOZjhk2dPwBkqgGtVd9lqU64FkfYcAVAuxnJbzFAyfS5AYARTssxztzVayPXt/iTuuK8Tzn9piXT5wQATcFzW+5X3KoDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADk5P8BajRsoUucHqIAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};

export const formattedTwoDigitNumber = (n) =>
  n.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });

const registers = ['No payment today.', '$95/driver per month after 30 days.'];
export const message = {
  markas: 'Mark as Primary Form of Payment',
  note: 'Note: Your card info will be used for monthly charging of payment per your subscription plan',
  account:
    'Please enter the two micro deposit made to your account in the verification link sent to your email. Once your account is verified, you can mark it as your primary payment account.',
  register: registers.join(' '),
  registers: registers,
};
